module.exports = __webpack_public_path__ + "static/drt3-c3d913dc4e828d0458f0cfa8e588c34e.jpg";